export const XS = 575;
export const SM = 767;
export const MD = 991;
export const LG = 1199;
export const XL = 1599;

export const SHOW_MENU_WIDTH = LG;
